import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { AccountShell } from "@/components/account";
import { useSeo } from "@/lib/seo";

export default function ForgotPassword() {
  useSeo({ title: "Reset password", path: "/forgot-password", noindex: true });
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.forgotPassword(email.trim().toLowerCase());
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <AccountShell title="Check your inbox" subtitle="If that email is registered, a password reset link is on its way. The link works once and expires in 1 hour.">
        <p className="auth-foot small"><Link to="/login" data-testid="forgot-back-login">Back to sign in</Link></p>
      </AccountShell>
    );
  }

  return (
    <AccountShell title="Reset your password" subtitle="Enter your email and we'll send a reset link.">
      <form onSubmit={submit}>
        <div className="field"><label htmlFor="fp-email">Email</label>
          <input id="fp-email" data-testid="forgot-email" type="email" required
            value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" /></div>
        <button className="btn blue auth-submit" data-testid="forgot-submit" disabled={busy}>
          {busy ? "Sending…" : "Send reset link"}</button>
      </form>
      <p className="auth-foot small"><Link to="/login" data-testid="forgot-back-login">Back to sign in</Link></p>
    </AccountShell>
  );
}
